// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const AssetAttributeCodeService = {};

AssetAttributeCodeService.getAssetAttributeCodeList = function (userInput) {
  return lossClient({
    url: "/AssetAttribute/Items?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

export default AssetAttributeCodeService;
